<template>
  <div class="p-grid">
    <div class="p-col-12">
      <div class="card">
        <Toolbar class="p-mb-4">
          <template slot="left">
            <Button
              label="New Attachment"
              icon="pi pi-plus"
              class="p-button-success p-mr-2"
              @click="openNew"
            />
          </template>

          <template slot="right">
            <span class="p-input-icon-left">
              <i class="pi pi-search" />
              <InputText
                v-model="filters['global']"
                placeholder="Global Search"
              />
            </span>
          </template>
        </Toolbar>
      </div>
    </div>
    <Dialog
      header="Confirmation"
      :visible.sync="displayConfirmation"
      :style="{ width: '350px', overflowY: 'auto' }"
      :modal="true"
    >
      <div class="confirmation-content">
        <i class="pi pi-exclamation-triangle p-mr-3" style="font-size: 2rem" />
        <span
          >The current attachment is attached to a quotation. Do you wish to
          delete the attachment?</span
        >
      </div>
      <template #footer>
        <Button
          label="No"
          icon="pi pi-times"
          @click="closeConfirmation"
          class="p-button-text"
        />
        <Button
          label="Yes"
          icon="pi pi-check"
          @click="confirmDeleteAttachment"
          class="p-button-text"
          autofocus
        />
      </template>
    </Dialog>
    <OverlayPanel
      :ref="'noteDetails'"
      @click="toggle1"
      appendTo="body"
      :showCloseIcon="true"
      id="noteDetails"
      style="width: 350px;"
    >
      <div style="padding: 0px 1px">
        <div class="row" style="background-color: white;">
          <div class="col col-lg-12 col-md-12">
            <strong>Note Details</strong>
          </div>
        </div>
        <div class="row" style="background-color: white;">
          <div class="col col-lg-12 col-md-12">
            <Textarea
              placeholder=""
              :autoResize="true"
              rows="6"
              v-model="noteDetails"
              :disabled="true"
              style="color: blue; width: 100%;"
            />
          </div>
        </div>
      </div>
    </OverlayPanel>

    <OverlayPanel
      :ref="'opActions'"
      @click="toggle"
      appendTo="body"
      :showCloseIcon="true"
      id="overlay_panel"
      style="width: 150px;"
      :baseZIndex="-10"
    >
      <div style="padding: 0px 1px">
        <div class="row" style="background-color: white;">
          <div class="col col-lg-12 col-md-12">
            <Button
              v-for="(obj, index) in getButtons(selectedRow)"
              :key="index"
              :label="obj.label"
              :icon="obj.icon"
              class="p-button-text p-button-plain"
              @click="obj.command()"
            />
          </div>
        </div>
      </div>
    </OverlayPanel>

    <DataTable
      :value="attachments"
      :paginator="true"
      class="p-datatable-striped p-datatable-sm p-datatable-gridlines p-datatable-customers"
      :rows="25"
      dataKey="noteId"
      :rowHover="true"
      :selection.sync="selectedNotes"
      :filters="filters"
      :loading="loading"
      paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
      :rowsPerPageOptions="[5, 10, 25]"
      currentPageReportTemplate="Showing {first} to {last} of {totalRecords} Attachments"
      :scrollable="true"
      scrollHeight="400px"
      frozenWidth="50px"
      :style="{ width: '100%' }"
      :resizableColumns="true"
      columnResizeMode="expand"
    >
      <!-- <template #header>
        <div class="table-header">Customer attachments</div>
      </template> -->

      <template #empty> No attachments found! </template>
      <template #loading> Loading Customer attachments. Please wait. </template>

      <Column
        header="Actions"
        headerStyle="width: 50px; padding: 7.5px 0px;"
        :frozen="true"
      >
        <template #body="slotProps">
          <div style="height: 26px; display: flex; align-items: center;">
            <Button
              icon="pi pi-ellipsis-h"
              class="p-button-rounded p-button-text"
              @click="toggleActions($event, slotProps.data)"
            />
          </div>
        </template>
      </Column>
      <Column
        field="attachId"
        header="Id"
        headerStyle="width: 5em"
        :sortable="true"
      >
        <template #body="slotProps">
          <div style="height: 26px;">
            {{ slotProps.data.attachId }}
          </div>
        </template>
      </Column>
      <Column field="fileName" header="Attachment Title" :sortable="true">
        <template #body="slotProps">
          <div style="height: 26px;">
            {{ slotProps.data.fileName }}
          </div>
        </template>
      </Column>
      <Column field="attachDesc" header="Details" :sortable="true">
        <template #body="slotProps">
          <div style="height: 26px;">
            {{
              slotProps.data.attachDesc
                ? slotProps.data.attachDesc.length > 18
                  ? slotProps.data.attachDesc.substring(0, 18) + "..."
                  : slotProps.data.attachDesc
                : ""
            }}
          </div>
        </template>
      </Column>
      <Column field="attachTags" header="Tags" :sortable="true">
        <template #body="slotProps">
          <div style="height: 26px;">
            {{ slotProps.data.attachTags }}
          </div>
        </template>
      </Column>
      <Column field="createdBy.fullName" header="Created By" :sortable="true">
        <template #body="slotProps">
          <div style="height: 26px;">
            {{ slotProps.data.createdBy.fullName }}
          </div>
        </template>
      </Column>
    </DataTable>

    <!-- Component to Create & Edit an attachments -->
    <AttachmentForm
      :attachment="attachment"
      :key="attachmentKey"
      :quotations="quotations"
      :quotation="quotation"
      :attachmentForm="attachmentForm"
      :customer="opportunity.customer"
      :hideQuotationVersionFields="false"
      @close="hideDialog"
      @saved="savedAttachment"
    />
  </div>
</template>

<script>
import AttachmentService from "@/service/AttachmentService";
import OpportunityService from "@/service/OpportunityService";

import AttachmentForm from "@/mbp/universalComponents/attachment/attachmentForm";
import PermissionMixin from "../../PermissionMixin.vue";
export default {
  components: {
    AttachmentForm
  },
  mixins: [PermissionMixin],
  props: ["opportunity"],
  data() {
    return {
      displayConfirmation: false,
      chooseQuote: true,
      attachments: null,
      //contacttypes: null,
      attachment: {},
      attachmentForm: false,
      selectedNotes: null,
      filters: {},
      expandedRows: [],
      quotations: [],
      quotation: {},
      file: {},
      FileUploads: true,
      attachmentKey1: 0,
      requesting: false,
      selectedRow: {},
      noteDetails: ""
    };
  },
  computed: {
    attachmentKey: {
      set(val) {
        this.attachmentKey1++;
      },
      get() {
        return "attachmentForm" + this.attachmentKey1.toString();
      }
    },
    loading() {
      if (this.attachments && this.attachments[0]) {
        return false;
      } else {
        if (this.requesting) {
          return true;
        } else {
          return false;
        }
      }
    }
  },
  attachmentService: null,
  opportunityService: null,
  created() {
    this.attachmentService = new AttachmentService();
    this.opportunityService = new OpportunityService();
  },
  mounted() {
    this.getAllOpportunityAttachments();
    this.opportunityService
      .getAllOpportunityQuotes(this.opportunity.oppId)
      .then(data => {
        this.quotations = data;
      })
      .catch(err => {
        // this.$toast.add({
        //   severity: "error",
        //   summary: "Error",
        //   detail: "Error while getting enquiry quotes",
        //   life: 5000,
        // })
        this.$store.dispatch("addErrorMessage", {
          severity: "error",
          content: 'Some data was not loaded from "opportunityquotes/{oppId}"'
        });
      });
  },
  watch: {
    attachmentForm(val) {
      this.attachmentKey++;
    },
    attachment(val) {
      if (val && val.quotation) {
        this.quotation = val.quotation;
      }
    }
  },
  methods: {
    openConfirmation(data) {
      this.$refs.opActions.toggle();
      this.attachment = data;
      this.displayConfirmation = true;
    },
    closeConfirmation() {
      this.displayConfirmation = false;
    },
    showNoteDetails(noteDetails, event) {
      this.noteDetails = noteDetails;
      this.toggle1(event);
    },
    async toggle1(event) {
      this.$refs.noteDetails.toggle(event);
    },
    async toggle(event) {
      this.$refs.op.toggle(event);
    },
    toggleActions(event, data) {
      this.selectedRow = data;
      this.$refs.opActions.toggle(event);
    },
    getButtons(data) {
      let buttons = [
        {
          label: "Download",
          icon: "pi pi-download",
          command: () => {
            this.download(data);
          }
        }
      ];
      this.checkPermissions();
      if (this.deleteAttachment) {
        buttons.push({
          label: "Delete",
          icon: "pi pi-trash",
          command: () => {
            this.openConfirmation(data);
          }
        });
      }
      return buttons;
    },
    confirmDeleteAttachment() {
      this.requesting = true;
      this.closeConfirmation();
      if (this.attachment && this.attachment.attachId) {
        this.attachmentService
          .deleteAttachment(this.attachment.attachId)
          .then(() => {
            this.getAllOpportunityAttachments();
            this.$toast.add({
              severity: "success",
              summary: "File deleted",
              detail: `Attachment deleted successfully.`,
              life: 5000
            });
          })
          .catch(error => {
            this.requesting = false;
            this.$toast.add({
              severity: "error",
              summary: "Error",
              detail: `Error while deleting attachment.`,
              life: 5000
            });
          });
      }
    },
    getAllOpportunityAttachments() {
      this.requesting = true;
      this.attachmentService
        .getAllOpportunityAttachments(this.opportunity.oppId)
        .then(data => {
          this.requesting = false;
          // this.attachments = data.filter(each => each.attachTags === 'Quotation')
          this.attachments = data;
        })
        .catch(err => {
          this.requesting = false;
          this.$store.dispatch("addErrorMessage", {
            severity: "error",
            content:
              'Some data was not loaded from "opportunityAttachments/{oppId}"'
          });
        });
    },
    download(data) {
      this.checkPermissions();
      if (this.downloadAttachment === false) {
        this.$toast.add({
          severity: "error",
          summary: "Not allowed",
          detail: "You don't have permission to download the attachment",
          life: 5000
        });
        return;
      }
      this.attachmentService.fileDownloader(data.fileName);
    },
    openNew() {
      this.file = {};
      this.attachment = {};
      this.attachmentForm = true;
    },
    hideDialog() {
      this.attachmentForm = false;
    },
    editAttachment(attachment) {
      this.quotation = attachment.quotation;
      this.attachment = { ...attachment };
      this.attachment.updatedBy = 101;
      this.attachmentForm = true;
    },
    savedAttachment({ file, attachment }) {
      this.getAllOpportunityAttachments();

      this.attachmentForm = false;
      this.attachment = {};
    }
  }
};
</script>

<style scoped lang="scss">
.p-progressbar {
  height: 0.5rem;
  background-color: #d8dadc;

  .p-progressbar-value {
    background-color: #607d8b;
  }
}

.p-datatable .p-column-filter {
  display: none;
}

.table-header {
  display: flex;
  justify-content: space-between;
}

.p-datatable.p-datatable-customers {
  .p-datatable-header {
    padding: 1rem;
    text-align: left;
    font-size: 1.5rem;
  }

  .p-paginator {
    padding: 1rem;
  }

  .p-datatable-thead > tr > th {
    text-align: left;
  }

  .p-datatable-tbody > tr > td {
    cursor: auto;
  }

  .p-dropdown-label:not(.p-placeholder) {
    text-transform: uppercase;
  }
}

/* Responsive */
.p-datatable-customers .p-datatable-tbody > tr > td .p-column-title {
  display: none;
}

.customer-badge {
  border-radius: 2px;
  padding: 0.25em 0.5rem;
  text-transform: uppercase;
  font-weight: 700;
  font-size: 12px;
  letter-spacing: 0.3px;

  &.status-qualified {
    background: #c8e6c9;
    color: #256029;
  }

  &.status-unqualified {
    background: #ffcdd2;
    color: #c63737;
  }

  &.status-negotiation {
    background: #feedaf;
    color: #8a5340;
  }

  &.status-new {
    background: #b3e5fc;
    color: #23547b;
  }

  &.status-renewal {
    background: #eccfff;
    color: #694382;
  }

  &.status-proposal {
    background: #ffd8b2;
    color: #805b36;
  }
}

.p-progressbar-value.ui-widget-header {
  background: #607d8b;
}

@media (max-width: 640px) {
  .p-progressbar {
    margin-top: 0.5rem;
  }
}

.product-image {
  width: 100px;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
}

.orders-subtable {
  padding: 1rem;
}

.product-badge {
  border-radius: 2px;
  padding: 0.25em 0.5rem;
  text-transform: uppercase;
  font-weight: 700;
  font-size: 12px;
  letter-spacing: 0.3px;

  &.status-instock {
    background: #c8e6c9;
    color: #256029;
  }

  &.status-outofstock {
    background: #ffcdd2;
    color: #c63737;
  }

  &.status-lowstock {
    background: #feedaf;
    color: #8a5340;
  }
}

.order-badge {
  border-radius: 2px;
  padding: 0.25em 0.5rem;
  text-transform: uppercase;
  font-weight: 700;
  font-size: 12px;
  letter-spacing: 0.3px;

  &.order-delivered {
    background: #c8e6c9;
    color: #256029;
  }

  &.order-cancelled {
    background: #ffcdd2;
    color: #c63737;
  }

  &.order-pending {
    background: #feedaf;
    color: #8a5340;
  }

  &.order-returned {
    background: #eccfff;
    color: #694382;
  }
}

@media screen and (max-width: 960px) {
  .p-datatable {
    &.p-datatable-customers {
      .p-datatable-thead > tr > th,
      .p-datatable-tfoot > tr > td {
        display: none !important;
      }

      .p-datatable-tbody > tr {
        border-bottom: 1px solid var(--layer-2);

        > td {
          text-align: left;
          display: block;
          border: 0 none !important;
          width: 100% !important;
          float: left;
          clear: left;
          border: 0 none;

          .p-column-title {
            padding: 0.4rem;
            min-width: 30%;
            display: inline-block;
            margin: -0.4rem 1rem -0.4rem -0.4rem;
            font-weight: bold;
          }

          .p-progressbar {
            margin-top: 0.5rem;
          }
        }
      }
    }
  }
}
</style>
